import { FFT, Window } from "@opendaw/lib-dsp";
export class AudioAnalyser {
    static DEFAULT_SIZE = 512;
    static DEFAULT_DECAY = 0.90;
    #fftSize;
    #numBins;
    #fft;
    #real;
    #imag;
    #window;
    #bins;
    #waveform;
    #decay;
    #index = 0;
    decay = false;
    constructor({ size, decay } = {}) {
        size ??= AudioAnalyser.DEFAULT_SIZE;
        this.#decay = decay ?? AudioAnalyser.DEFAULT_DECAY;
        this.#fftSize = size << 1;
        this.#fft = new FFT(this.#fftSize);
        this.#real = new Float32Array(this.#fftSize);
        this.#imag = new Float32Array(this.#fftSize);
        this.#window = Window.create(Window.Type.Blackman, this.#fftSize);
        this.#numBins = size;
        this.#bins = new Float32Array(size);
        this.#waveform = new Float32Array(size);
    }
    clear() {
        this.#bins.fill(0.0);
        this.#real.fill(0.0);
        this.#waveform.fill(0.0);
        this.#index = 0;
    }
    reset() {
        this.#index = 0;
    }
    numBins() { return this.#numBins; }
    bins() { return this.#bins; }
    waveform() { return this.#waveform; }
    process(left, right, fromIndex, toIndex) {
        for (let i = fromIndex; i < toIndex; ++i) {
            this.#real[this.#index] = left[i] + right[i];
            if (++this.#index === this.#fftSize) {
                this.#update();
            }
        }
    }
    #update() {
        for (let i = 0; i < this.#numBins; ++i) {
            this.#waveform[i] = this.#real[i << 1];
        }
        for (let i = 0; i < this.#fftSize; ++i) {
            this.#real[i] *= this.#window[i];
        }
        this.#fft.process(this.#real, this.#imag);
        const scale = 1.0 / this.#numBins;
        for (let i = 0; i < this.#numBins; ++i) {
            const re = this.#real[i];
            const im = this.#imag[i];
            const energy = Math.sqrt(re * re + im * im) * scale;
            if (this.#bins[i] < energy) {
                this.#bins[i] = energy;
            }
            else if (this.decay) {
                this.#bins[i] *= this.#decay;
            }
        }
        this.#index = 0;
        this.#imag.fill(0.0);
        this.decay = false;
    }
}
